import type { FC, PropsWithChildren, ReactNode } from "react"
import { Box } from "@mui/material"

import { SectionCard } from "widgets/styled/containers"
import SectionHeader from "./SectionHeader"

interface CardWithTitleProps {
  titleKey: string
  tooltipContent?: ReactNode[]
  actionPermission?: boolean
  isDoingAction?: boolean
  handleAction?: () => void
  actionIcon?: ReactNode
}

const CardWithTitle: FC<PropsWithChildren<CardWithTitleProps>> = ({
  titleKey,
  tooltipContent,
  actionPermission = true,
  isDoingAction = false,
  handleAction,
  actionIcon,
  children,
}) => {
  return (
    <SectionCard
      sx={{
        margin: 0,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <SectionHeader
        titleKey={titleKey}
        tooltipContent={tooltipContent}
        actionPermission={actionPermission}
        isDoingAction={isDoingAction}
        handleAction={handleAction}
        actionIcon={actionIcon}
      />
      <Box p={2.5} height={"100%"} display={"flex"} flexDirection={"column"}>
        {children}
      </Box>
    </SectionCard>
  )
}

export default CardWithTitle
